<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button type="primary" :size="$store.state.buttonSize" @click="SupplierEdit()"
          >新增供应商</el-button
        >
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="merchantName" label="供应商名称">
        <template slot-scope="scope">
          <el-button type="text" @click="detailShow(scope.row.id)">{{ scope.row.merchantName }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="shortName" label="供应商简称"> </el-table-column>
      <el-table-column prop="license" label="生产许可证号"> </el-table-column>
      <el-table-column prop="contacts" label="联系人"> </el-table-column>
      <el-table-column prop="phoneNum" label="联系电话"> </el-table-column>
      <el-table-column prop="email" label="邮箱"> </el-table-column>
      <el-table-column prop="address" label="联系地址"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | format }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="SupplierEdit(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="SupplierDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 新增供应商 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="supplierAddFormVisible" center>
      <el-form
        :model="supplierAddForm"
        :size="$store.state.formSize"
        :rules="supplierAddFormRules"
        ref="refsupplierAddForm"
        label-width="140px"
      >
        <el-form-item label="供应商名称：" prop="merchantName">
          <el-input
            v-model="supplierAddForm.merchantName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="简称：">
          <el-input
            v-model="supplierAddForm.shortName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="生产许可证号：">
          <el-input
            v-model="supplierAddForm.license"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属区域：" prop="adminArea">
          <el-cascader
            :props="props"
            :placeholder="supplierAddForm.adminAreaStr"
            v-model="supplierAddForm.adminArea"
            @change="townSelect($event)"
            @expand-change="citySelect($event)"
            style="width:100%;"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="地址：" prop="address">
          <el-input
            v-model="supplierAddForm.address"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人：" prop="contacts">
          <el-input
            v-model="supplierAddForm.contacts"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phoneNum">
          <el-input
            v-model="supplierAddForm.phoneNum"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input
            v-model="supplierAddForm.email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="传真：">
          <el-input v-model="supplierAddForm.fax" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="supplierAddForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :size="$store.state.buttonSize" :disabled="isDisabled" @click="add">确 定</el-button>
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 详细信息 -->
    <el-drawer title="" :visible.sync="drawer" size="40%" :with-header="false">
      <div class="content-detail">
        <h2>
          <i class="el-icon-circle-close" @click="drawer = false"></i>
          <span>供应商详细信息</span>
        </h2>
        <el-divider></el-divider>
        <table class="content-detail-table">
          <tr>
            <td class="list-item">供应商名称</td>
            <td>{{ detailDate.merchantName }}</td>
            <td class="list-item">供应商简称</td>
            <td>{{ detailDate.shortName }}</td>
          </tr>
          <tr>
            <td class="list-item">详细地址</td>
            <td>{{ detailDate.address }}</td>
            <td class="list-item">所属区域</td>
            <td>{{ detailDate.provinceName + detailDate.cityName + detailDate.countyName + detailDate.townName }}</td>
          </tr>
          <tr>
            <td class="list-item">联系人</td>
            <td>{{ detailDate.contacts }}</td>
            <td class="list-item">邮箱</td>
            <td>{{ detailDate.email }}</td>
          </tr>
          <tr>
            <td class="list-item">联系电话</td>
            <td>{{ detailDate.phoneNum }}</td>
            <td class="list-item">传真</td>
            <td>{{ detailDate.fax }}</td>
          </tr>
          <tr>
            <td class="list-item">创建时间</td>
            <td>{{ detailDate.createTime | format }}</td>
            <td class="list-item">备注</td>
            <td>{{ detailDate.remark }}</td>
          </tr>
        </table>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import {
  getTrackMerchant,
  putTrackMerchantSupplier,
  getTrackMerchantDetail,
  postTrackMerchantSupplier,
  deleteMerchantDel,
  delMerchantList
} from '@/api/merchant'
import { getCity } from '@/api/city'
const createForm = () => ({
  address: '',
  contacts: '',
  province: '',
  city: '',
  county: '',
  town: '',
  fax: '',
  email: '',
  license: '',
  merchantName: '',
  shortName: '',
  phoneNum: '',
  remark: '',
  adminArea: [],
  adminAreaStr: ''
})

export default {
  data() {
    return {
      supplierAddFormVisible: false,
      total: 0,
      size: 10,
      page: 1,
      drawer: false,
      keywords: '',
      detailDate: {},
      tableData: [],
      supplierAddForm: createForm(),
      currentID: null,
      isDisabled: false,
      supplierAddFormRules: {
        merchantName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        phoneNum: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        adminArea: [
          { required: true, message: '请选择所属区域', trigger: 'blur' }
        ]
      },
      props: {
        // 获取管理区域城市tree
        emitPath: false,
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node
          let valueArr = []
          if (value) {
            valueArr = value.split(',')
          }
          getCity({
            code: valueArr[0] || '100000000'
          }).then(res => {
            const nodes = Array.from(res.data).map(item => ({
              label: item.name,
              value: item.code + ',' + item.id,
              code: item.code,
              // 判断最后一层
              leaf: item.type > 3
            }))
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes)
          })
        }
      },
      loading: true,
      selectionID: []
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑供应商' : '新增供应商'
    }
  },
  created() {
    this.debounceAdd = debounce(300, this.add)
    this.debounceEdit = debounce(300, this.edit)
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delMerchantList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getSupplierListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    hanleResetFormVals() {
      this.supplierAddFormVisible = false
      this.$set(this, 'supplierAddForm', createForm())
      this.$refs.refsupplierAddForm.clearValidate()
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getSupplierListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getSupplierListData()
    },
    citySelect(event) {
      if (event.length > 2) {
        this.supplierAddForm.province = parseInt(event[0].split(',')[1])
        this.supplierAddForm.city = parseInt(event[1].split(',')[1])
        this.supplierAddForm.county = parseInt(event[2].split(',')[1])
      }
    },
    townSelect(event) {
      this.supplierAddForm.town = parseInt(event.split(',')[1])
    },
    // 删除供应商
    SupplierDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteMerchantDel({
            id: id
          }).then(res => {
            if (res.status === 1) {
              this.$message.success('删除供应商成功')
              this.getSupplierListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 新增供应商
    add() {
      this.$refs.refsupplierAddForm.validate(valid => {
        if (!valid) return false
        const changeClasses = this.currentID
          ? postTrackMerchantSupplier
          : putTrackMerchantSupplier
        changeClasses({
          address: this.supplierAddForm.address,
          contacts: this.supplierAddForm.contacts,
          province: this.supplierAddForm.province,
          city: this.supplierAddForm.city,
          county: this.supplierAddForm.county,
          town: this.supplierAddForm.town,
          fax: this.supplierAddForm.fax,
          email: this.supplierAddForm.email,
          license: this.supplierAddForm.license,
          merchantName: this.supplierAddForm.merchantName,
          shortName: this.supplierAddForm.shortName,
          phoneNum: this.supplierAddForm.phoneNum,
          remark: this.supplierAddForm.remark,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID ? this.$message.success('编辑供应商成功') : this.$message.success('新增供应商成功')
            this.supplierAddFormVisible = false
            this.getSupplierListData()
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 修改供应商
    SupplierEdit(id) {
      const isAdd = !id
      this.supplierAddFormVisible = true

      if (isAdd) {
        this.$set(this, 'supplierAddForm', createForm())
        this.currentID = null
      } else {
        this.isDisabled = true
        this.currentID = id
        getTrackMerchantDetail(1, id).then(res => {
          if (res.status === 1) {
            Object.keys(createForm()).forEach(key => {
              if (key in res.data) {
                this.supplierAddForm[key] = res.data[key]
              }
            })
            this.supplierAddForm.adminArea = [
              res.data.provincx,
              res.data.city,
              res.data.county,
              res.data.town
            ]
            this.supplierAddForm.adminAreaStr = [
              res.data.provinceName,
              res.data.cityName,
              res.data.countyName,
              res.data.townName
            ].join('/')
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getSupplierListData()
    },
    // 刷新数据表格
    refresh() {
      this.getSupplierListData()
      this.$message.success('数据刷新成功')
    },
    // 详情
    detailShow(id) {
      this.drawer = true
      getTrackMerchantDetail(1, id).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.detailDate = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取供应商列表
    getSupplierListData() {
      this.loading = true
      getTrackMerchant({
        type: 1,
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    }
  },
  mounted() {
    this.getSupplierListData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
